import { InaReportResult } from './model/ina-report-result.model';
import { InaReportService } from './service/ina-report.service';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';
import { School, Grade } from 'src/app/model/school.model';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import moment from 'moment';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UtilityService } from 'src/app/service/utility.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';

@Component({
    selector: 'app-ina-report',
    templateUrl: './ina-report.component.html',
    styleUrls: ['./ina-report.component.scss']
})
export class InaReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];
    isExporting: boolean = false;
    hasExports: boolean = false;

    rAttending: boolean = false;
    rNotAttending: boolean = false;

    withoutEip: boolean = true;
    expiredQad: boolean = true;
    withoutIna: boolean = false;

    grades: Grade[] = [];

    // Component variables
    resetField: boolean = false;
    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;
    progressSubscription: Subscription;
    progressInterval: number = 500;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstINAILPResponse: InaReportResult[];
    strExportFileName = 'INA-ILP_Report';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Table display
    baseDisplayedColumns: string[] = [
        'REGION_CODE',
        'SCHOOL_NAME',
        'INA_REPORT_SECTIONS.PERSONAL_GRADE',
        'ENROLLMENT_TYPE',
        'INA_REPORT_SECTIONS.PERSONAL_MSD',
        'INA_REPORT_SECTIONS.PERSONAL_SSID',
        'INA_REPORT_SECTIONS.PERSONAL_NAME',
        'INA_REPORT_SECTIONS.PERSONAL_DOB',
        'INA_REPORT_SECTIONS.PERSONAL_QAD',
        'CURRENT_REGION_EOE_DATE',
        'DEPARTURE_DATE',
        'STATUS_TYPE',
        'INA_REPORT_SECTIONS.CREATED_BY_FIRST_NAME',
        'INA_REPORT_SECTIONS.FOLLOW_UP_BY_FIRST_NAME'
    ];
    suffixColumns: string[] = [];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSource!: MatTableDataSource<InaReportResult>;

    // Results
    results: InaReportResult[] = [];
    filter: string = '';

    currentSetting: any;
    isLoadingResults: boolean = false;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    inaFilters = {
        'Only include P3-P5 children enrolled in non-MEP preschools': {
            INDEX: 1,
            ENABLED: false,
            DATA: 'PRESCHOOL_ENROLLED_IN_NON_MEP_SCHOOL',
            DISABLED: false,
            TOOLTIP: { ID: 'InaIlpReport_PreschoolEnrolled' }
        },
        'Only include secondary students who are credit deficient': {
            INDEX: 2,
            ENABLED: false,
            DATA: 'SECONDARY_ACADEMIC_REVIEW_CREDIT_DEFICIENT',
            DISABLED: false,
            TOOLTIP: { ID: 'InaIlpReport_SecondaryAcademicReview' }
        },
        'Only include youths who dropped out of school': {
            INDEX: 3,
            ENABLED: false,
            DATA: 'ADULT_EDUCATION_DROPPED_OUT',
            DISABLED: false,
            TOOLTIP: { ID: 'InaIlpReport_AdultEducation' }
        },
        'Only include children/youths without health insurance': {
            INDEX: 4,
            ENABLED: false,
            DATA: 'HEALTH_INFORMATION_HEALTH_INSURANCE',
            DISABLED: false,
            TOOLTIP: { ID: 'InaIlpReport_YouthsWithoutHealthInsurance' }
        },
        'Only include children/youths with health concerns': {
            INDEX: 5,
            ENABLED: false,
            DATA: 'HEALTH_INFORMATION_HEALTH_CONCERNS',
            DISABLED: false,
            TOOLTIP: { ID: 'InaIlpReport_HealthInformation' }
        }
    };
    chosenInaFilter: string = '';

    selectedFilters: string[] = [];
    selectedFilterOptions: string[] = [];
    currentFilter: string;

    inaResultFilters = {
        Grades: {
            INDEX: 1,
            ENABLED: false,
            DISABLED: false,
            DATA: 'INA_REPORT_SECTIONS.PERSONAL_GRADE',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'P3', ENABLED: false, DISABLED: false },
                { FILTER: 'P4', ENABLED: false, DISABLED: false },
                { FILTER: 'P5', ENABLED: false, DISABLED: false },
                { FILTER: 'TK', ENABLED: false, DISABLED: false },
                { FILTER: 'K', ENABLED: false, DISABLED: false },
                { FILTER: '01', ENABLED: false, DISABLED: false },
                { FILTER: '02', ENABLED: false, DISABLED: false },
                { FILTER: '03', ENABLED: false, DISABLED: false },
                { FILTER: '04', ENABLED: false, DISABLED: false },
                { FILTER: '05', ENABLED: false, DISABLED: false },
                { FILTER: '06', ENABLED: false, DISABLED: false },
                { FILTER: '07', ENABLED: false, DISABLED: false },
                { FILTER: '08', ENABLED: false, DISABLED: false },
                { FILTER: '09', ENABLED: false, DISABLED: false },
                { FILTER: '10', ENABLED: false, DISABLED: false },
                { FILTER: '11', ENABLED: false, DISABLED: false },
                { FILTER: '12', ENABLED: false, DISABLED: false },
                { FILTER: 'AD', ENABLED: false, DISABLED: false },
                { FILTER: 'NA', ENABLED: false, DISABLED: false }
            ]
        },
        'INA/ILP Status': {
            INDEX: 2,
            ENABLED: false,
            DISABLED: false,
            DATA: 'STATUS_TYPE',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'Completed', ENABLED: false, DISABLED: false },
                { FILTER: 'Started', ENABLED: false, DISABLED: false }
            ]
        },
        'INA/ILP Type': {
            INDEX: 3,
            ENABLED: false,
            DISABLED: false,
            DATA: 'TERM_DURATION',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'Annual', ENABLED: false, DISABLED: false },
                { FILTER: '30 Day/Initial', ENABLED: false, DISABLED: false }
            ]
        },
        'Indicators/Statuses': {
            INDEX: 4,
            ENABLED: false,
            DISABLED: false,
            YES: true,
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'PFS = Yes', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.INDICATORS_PFS' },
                { FILTER: 'Academic Risk = Yes', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.INDICATORS_ACADEMIC_RISK' },
                { FILTER: 'Special Ed = Yes', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.INDICATORS_IEP' },
                { FILTER: '504 Plan = Yes', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.INDICATORS_504_PLAN' }
            ]
        },
        'Met Assessment Standards': {
            INDEX: 5,
            ENABLED: false,
            DISABLED: false,
            NO: true,
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'ELA = No', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.ACADEMIC_REVIEW_ELA_PROFICIENT' },
                { FILTER: 'Math = No', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.ACADEMIC_REVIEW_MATH_PROFICIENT' },
                { FILTER: 'ELPAC = No', ENABLED: false, DISABLED: false, DATA: 'INA_REPORT_SECTIONS.ACADEMIC_REVIEW_ELPAC_PROFICIENT' }
            ]
        },
        'Health Needs': {
            INDEX: 6,
            ENABLED: false,
            DISABLED: false,
            DATA: 'INA_REPORT_SECTIONS.HEALTH_INFORMATION_HEALTH_NEEDS',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'Medical', ENABLED: false, DISABLED: false },
                { FILTER: 'Dental', ENABLED: false, DISABLED: false },
                { FILTER: 'Vision', ENABLED: false, DISABLED: false },
                { FILTER: 'Mental Health', ENABLED: false, DISABLED: false },
                { FILTER: 'Other', ENABLED: false, DISABLED: false },
                { FILTER: 'None', ENABLED: false, DISABLED: false }
            ]
        },
        'Emergency Service Needs': {
            INDEX: 7,
            ENABLED: false,
            DISABLED: false,
            DATA: 'INA_REPORT_SECTIONS.HEALTH_INFORMATION_EMERGENCY_SERVICES',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'Food', ENABLED: false, DISABLED: false },
                { FILTER: 'Housing', ENABLED: false, DISABLED: false },
                { FILTER: 'Clothing', ENABLED: false, DISABLED: false },
                { FILTER: 'Health', ENABLED: false, DISABLED: false }
            ]
        },
        'OSY Type': {
            INDEX: 8,
            ENABLED: false,
            DISABLED: false,
            DATA: 'INA_REPORT_SECTIONS.OSY_YOUTH_IS',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'Here-to-work', ENABLED: false, DISABLED: false },
                { FILTER: 'Recovery', ENABLED: false, DISABLED: false }
            ]
        },
        'OSY Participation': {
            INDEX: 9,
            ENABLED: false,
            DISABLED: false,
            DATA: 'INA_REPORT_SECTIONS.OSY_INTERESTED_IN',
            COUNT: 0,
            OPTIONS: [
                { FILTER: 'English (ELA, ESL, ELD)', ENABLED: false, DISABLED: false },
                { FILTER: 'GED/HEP', ENABLED: false, DISABLED: false },
                { FILTER: 'Home Language Literacy', ENABLED: false, DISABLED: false },
                { FILTER: 'Job training/CTE', ENABLED: false, DISABLED: false },
                { FILTER: 'Other', ENABLED: false, DISABLED: false },
                { FILTER: 'None', ENABLED: false, DISABLED: false }
            ]
        }
    };

    constructor(
        public pagingService: PagingService,
        private dialog: MatDialog,
        private inaReportService: InaReportService,
        private apiMsinExportsService: ApiExportsService,
        private utilityService: UtilityService
    ) {}

    ngOnInit(): void {}

    search() {
        if (this.checkValid() && (this.rAttending || this.rNotAttending)) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.inaReportService.searchINAReports(this.generatePayload()).subscribe({
                next: (res) => {
                    if (res.inaReports) {
                        this.results = res.inaReports.sort((n1: InaReportResult, n2: InaReportResult) =>
                            n1.INA_REPORT_SECTIONS?.PERSONAL_NAME! > n2.INA_REPORT_SECTIONS?.PERSONAL_NAME! ? 1 : -1
                        );

                        let prefixColumns: string[] = [];
                        this.displayedColumns = this.generateDisplayColumns(this.selectedSchoolYear, prefixColumns);
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving INA/ILP Report.' };
                    }
                    this.isLoading = false;
                },
                error: (err) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving INA/ILP Report.' };
                    this.isLoading = false;
                },
                complete: () => {
                    // Updates the Tables to be displayed w/ this.results
                    if (this.results.length > 0) {
                        this.updateDataSource();
                    }

                    // Display current performance period
                    this.currentSchoolYear = this.selectedSchoolYear;

                    // Display results
                    this.isLoading = false;
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please select an Enrollment Type.' };
            this.isLoading = false;
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.chosenRegions.map((obj) => obj.ID).join(',');
        payload.chosenCounties = this.chosenCounties.map((obj) => obj.ID).join(',');
        payload.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID).join(',');
        payload.chosenSchools = this.chosenSchools.map((obj) => obj.ID).join(',');
        payload.schoolYear = this.selectedSchoolYear;

        let enrollmentTypes = [];
        this.rAttending ? enrollmentTypes.push('R') : null;
        this.rNotAttending ? enrollmentTypes.push('N') : null;
        payload.enrollmentTypes = enrollmentTypes.join(',');

        payload.withoutEip = this.withoutEip ? 1 : 0;
        payload.expiredQad = this.expiredQad ? 1 : 0;
        payload.withoutIna = this.withoutIna ? 1 : 0;

        payload.filterCategory = this.chosenInaFilter;

        return payload;
    }

    generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];

        displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        return displayedColumns;
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<InaReportResult>();
            this.tableDataSource.data = this.results;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'INA_REPORT_SECTIONS.PERSONAL_MSD', direction: 'asc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            // Update filtered results
            this.updateFilterResults(false);
        });
    }

    setFilter() {
        this.tableDataSource.filter = this.filter.trim().toLocaleLowerCase();
    }

    updateFilterResults(open: any) {
        if (open) {
            if (this.selectedFilters.length > 0) {
                if (this.selectedFilters.indexOf(this.currentFilter) < 0) {
                    this.selectedFilters = this.selectedFilters.sort((n1: string, n2: string) => (n1 > n2 ? 1 : -1));
                    this.currentFilter = this.selectedFilters[0];
                }
            } else {
                this.currentFilter = '';
            }
        } else {
            let hasOption = false;

            let reducedInaResultFilters: any = {};
            let inaResultFilters: any = this.inaResultFilters;
            let inaResultFilterKeys = Object.keys(inaResultFilters);

            let output: any[] = [];

            inaResultFilterKeys.forEach((filter) => {
                if (inaResultFilters[filter].ENABLED) {
                    reducedInaResultFilters[filter] = (({ INDEX, ENABLED, DISABLED, DATA, YES, NO }) => ({ INDEX, ENABLED, DISABLED, DATA, YES, NO }))(
                        inaResultFilters[filter]
                    );

                    reducedInaResultFilters[filter].OPTIONS = [];

                    inaResultFilters[filter].OPTIONS.forEach((option: any) => {
                        if (option.ENABLED) {
                            hasOption = true;
                            reducedInaResultFilters[filter].OPTIONS.push(option);
                        }
                    });
                }
            });

            if (
                (inaResultFilters && Object.keys(inaResultFilters).length === 0 && Object.getPrototypeOf(inaResultFilters) === Object.prototype) ||
                !hasOption
            ) {
                if (this.results.length > 0) {
                    this.tableDataSource.data = this.results;
                }
            } else {
                this.results.forEach((r) => {
                    let found = false;

                    let inaResultFilterKeys = Object.keys(reducedInaResultFilters);

                    for (let filter of inaResultFilterKeys) {
                        if (parseInt(this.getPropertyPipe.transform(reducedInaResultFilters, filter + '.OPTIONS.length')) > 0) {
                            found = reducedInaResultFilters[filter].OPTIONS.find((option: any) => {
                                if (reducedInaResultFilters[filter].YES) {
                                    const raw = this.getPropertyPipe.transform(r, option.DATA);
                                    const dataLowercase = String(raw ?? '').toLowerCase();
                                    if (dataLowercase === 'yes') {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } else if (reducedInaResultFilters[filter].NO) {
                                    const raw = this.getPropertyPipe.transform(r, option.DATA);
                                    const dataLowercase = String(raw ?? '').toLowerCase();
                                    if (dataLowercase === 'no') {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                } else {
                                    if (this.getPropertyPipe.transform(r, reducedInaResultFilters[filter].DATA)) {
                                        if (
                                            this.getPropertyPipe
                                                .transform(r, reducedInaResultFilters[filter].DATA)
                                                .toString()
                                                .toLowerCase()
                                                .indexOf(option.FILTER.toLowerCase()) >= 0
                                        ) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    } else {
                                        return false;
                                    }
                                }
                            });

                            if (!found) {
                                break;
                            }
                        }
                    }

                    if (found) {
                        output.push(r);
                    }
                });

                if (this.results.length > 0) {
                    this.tableDataSource.data = output;
                }
            }
        }
    }

    checkValid() {
        let bRet: boolean = false;
        if (this.chosenRegions.length > 0 && this.selectedSchoolYear) {
            bRet = true;
        } else {
            bRet = false;
        }

        return bRet;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedSchoolYear = performancePeriod;
    }

    // Filter Emiiters
    gradeEventEmitter(grades: Grade[]) {
        this.grades = grades;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To reset the value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.rAttending = false;
        this.rNotAttending = false;
        this.withoutEip = true;
        this.expiredQad = true;
        this.withoutIna = false;

        this.chosenInaFilter = '';

        this.selectedFilters = [];
        this.selectedFilterOptions = [];

        this.checkbox([], this.inaResultFilters);
        this.checkboxOption([], this.inaResultFilters);

        this.msg = {};
    }

    selectAllFilters(obj: any) {
        let inaResultFilterKeys = Object.keys(obj);

        this.checkbox(inaResultFilterKeys, obj);

        this.selectedFilters = inaResultFilterKeys;
    }

    deSelectAllFilters(obj: any) {
        this.checkbox([], obj);

        this.selectedFilters = [];
    }

    selectAllOptions(filter: string) {
        let inaResultFilters: any = this.inaResultFilters;

        if (inaResultFilters[filter]) {
            let options = inaResultFilters[filter].OPTIONS.map((option: any) => filter + option.FILTER);

            this.selectedFilterOptions = [...new Set([...this.selectedFilterOptions, ...options])];
            this.selectedFilterOptions = this.selectedFilterOptions.sort((n1: string, n2: string) => (n1 > n2 ? 1 : -1));

            this.checkboxOption(this.selectedFilterOptions, inaResultFilters);
        }
    }

    deSelectAllOptions(filter: string) {
        let inaResultFilters: any = this.inaResultFilters;

        if (inaResultFilters[filter]) {
            let options = inaResultFilters[filter].OPTIONS.map((option: any) => filter + option.FILTER);

            this.selectedFilterOptions = this.selectedFilterOptions.filter((selectedOption: string, index: number) => {
                if (options.indexOf(selectedOption) >= 0) {
                    return false;
                } else {
                    return true;
                }
            });

            this.checkboxOption(this.selectedFilterOptions, inaResultFilters);
        }
    }

    announceSortChange(sortState: Sort) {}

    checkbox(properties: string[], obj: any) {
        let inaResultFilters: any = obj;
        let inaResultFilterKeys = Object.keys(inaResultFilters);

        inaResultFilterKeys.forEach((filter: string) => {
            if (properties.indexOf(filter) >= 0) {
                inaResultFilters[filter].ENABLED = true;
            } else {
                inaResultFilters[filter].ENABLED = false;
            }
        });
    }

    checkboxOption(properties: string[], obj: any) {
        let inaResultFilters: any = obj;
        let inaResultFilterKeys = Object.keys(inaResultFilters);

        inaResultFilterKeys.forEach((filter: string) => {
            inaResultFilters[filter].OPTIONS.forEach((option: any) => {
                if (properties.indexOf(filter + option.FILTER) >= 0) {
                    option.ENABLED = true;
                } else {
                    option.ENABLED = false;
                }
            });

            inaResultFilters[filter].COUNT = this.selectionCount(inaResultFilters, filter);
        });
    }

    selectionCount(obj: any, key: string) {
        let count: number = 0;

        if (obj[key]) {
            if (obj[key].OPTIONS) {
                obj[key].OPTIONS.forEach((option: any) => {
                    if (option.ENABLED) {
                        count += 1;
                    }
                });
            }
        }

        return count;
    }

    isQadExpired(EoeDate: string) {
        if (moment(EoeDate).isValid()) {
            let expiredDay = new Date(moment(EoeDate).format('LL'));
            const today = new Date(moment().format('LL'));

            if (expiredDay < today) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    downloadExcel() {
        let payload = this.generateExportPayload('Excel');

        if (payload.data.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportInaIlpReport(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'application/xlsx' });

                    let fileName = this.utilityService.fnMakeFileNameTime('INA_ILP_Report_');

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.xlsx';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting INA/ILP Report.' };
                    this.isExporting = false;
                },
                complete: () => {
                    this.isExporting = false;
                }
            });
        }
    }

    generateExportPayload(fileType: string) {
        let payload = {
            settings: {
                fileType: fileType
            },
            data: this.tableDataSource.data
        };

        return payload;
    }
}
